/* eslint-disable @typescript-eslint/naming-convention */
export enum meridiansEnum {
    AM = 'AM',
    PM = 'PM'
}
